import { render, staticRenderFns } from "./EmployeesReport.vue?vue&type=template&id=4d588d38"
import script from "./EmployeesReport.vue?vue&type=script&lang=js"
export * from "./EmployeesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports